export default __webpack_public_path__ + "static/media/sell-image4.fe63d0ff.png";